import React, { useState, useEffect } from 'react';
import AdminHeader from '../components/AdminHeader';
import Select from 'react-select';
import '../adminSide/customStyles.css';

function SubCategoryAdd() {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedItemObj, setSelectedItemObj] = useState(null);
    const [offerPrice, setOfferPrice] = useState('');

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        fetch(`${apiBaseUrl}/getCategories/BLACKBATON_2526`)
            .then(response => response.json())
            .then(data => setCategories(data));
    }, [apiBaseUrl]);

    useEffect(() => {
        if (selectedCategory) {
            fetch(`${apiBaseUrl}/getProductByCategory/BLACKBATON_2526?Id=${selectedCategory}`)
                .then(response => response.json())
                .then(data => setItems(data.map(item => ({
                    Id: item.ID,
                    ItemName: item.ItemName,
                    MRP: item.MRP,
                }))));
        }
    }, [selectedCategory, apiBaseUrl]);

    const handleCategoryChange = (selectedCategory) => {
        setSelectedCategory(selectedCategory ? selectedCategory.value : '');
        setSelectedItem('');
        setSelectedImage(null);
    };


    const handleItemChange = (selectedOption) => {
        const itemId = selectedOption ? selectedOption.value : '';
        setSelectedItem(itemId);
        const itemObj = items.find(item => item.Id === itemId);
        setSelectedItemObj(itemObj || null);
        setSelectedImage(null);
    };

    const handleSubmit = async () => {
        if (!selectedItemObj || !offerPrice) {
            alert('Please select an item and enter an offer price.');
            return;
        }

        const payload = {
            categoryName: categories.find(cat => cat.Id === selectedCategory)?.Name || '',
            itemId: selectedItemObj.Id,
            itemName: selectedItemObj.ItemName,
            mrp: selectedItemObj.MRP,
            offerPrice: offerPrice
        };

        try {
            const response = await fetch(`${apiBaseUrl}/addOffer`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (response.ok) {
                alert('Offer added successfully!');
                setSelectedCategory('');
                setSelectedItem('');
                setSelectedItemObj(null);
                setOfferPrice('');
            } else {
                alert(data.error || 'Something went wrong.');
            }
        } catch (error) {
            console.error('Error submitting offer:', error);
            alert('Server error.');
        }
    };





    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-dmSans">
            <AdminHeader />

            <div className="flex-grow flex items-center justify-center py-12 px-4 shadow-inner">
                <div className="w-full max-w-2xl bg-white shadow-2xl rounded-2xl border border-gray-100 overflow-hidden animate-in">
                    <div className="bg-black py-8 px-6">
                        <h1 className="text-3xl font-extrabold text-center text-white font-montserrat tracking-tight uppercase">Add to SubCategories</h1>
                        <p className="text-gray-400 text-center mt-2 text-sm uppercase tracking-widest font-medium">Manage product grouping</p>
                    </div>

                    <div className="p-8 space-y-6">
                        <div className="space-y-2">
                            <label className="text-xs uppercase tracking-widest font-bold text-gray-500 ml-1">Select Category</label>
                            <Select
                                onChange={handleCategoryChange}
                                options={categories.map(category => ({ value: category.Id, label: category.Name }))}
                                className="premium-select"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderRadius: '12px',
                                        padding: '4px',
                                        border: '1px solid #e5e7eb',
                                        boxShadow: 'none',
                                        '&:hover': { border: '1px solid #000' }
                                    })
                                }}
                                isClearable
                                isSearchable
                                placeholder="Choose a category..."
                            />
                        </div>

                        {selectedCategory && (
                            <div className="space-y-6 animate-in">
                                <div className="space-y-2">
                                    <label className="text-xs uppercase tracking-widest font-bold text-gray-500 ml-1">Select Item</label>
                                    <Select
                                        onChange={handleItemChange}
                                        options={items.map(item => ({ value: item.Id, label: item.ItemName }))}
                                        className="premium-select"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                borderRadius: '12px',
                                                padding: '4px',
                                                border: '1px solid #e5e7eb',
                                                boxShadow: 'none',
                                                '&:hover': { border: '1px solid #000' }
                                            })
                                        }}
                                        isClearable
                                        isSearchable
                                        placeholder="Choose an item..."
                                    />
                                </div>

                                {selectedItemObj && (
                                    <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 space-y-6 animate-in">
                                        <div className="flex justify-between items-center">
                                            <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">Market Retail Price</span>
                                            <span className="text-xl font-bold font-montserrat">₹{selectedItemObj.MRP}</span>
                                        </div>

                                        <div className="space-y-2">
                                            <label className="text-xs uppercase tracking-widest font-bold text-gray-500 ml-1">Offer Price</label>
                                            <div className="relative">
                                                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-bold">₹</span>
                                                <input
                                                    type="number"
                                                    className="w-full pl-8 pr-4 py-3 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-1 focus:ring-black transition-all font-montserrat font-semibold"
                                                    value={offerPrice}
                                                    onChange={(e) => setOfferPrice(e.target.value)}
                                                    placeholder="Enter price..."
                                                />
                                            </div>
                                        </div>

                                        <button
                                            onClick={handleSubmit}
                                            className="w-full bg-black text-white py-4 px-6 rounded-xl font-bold uppercase tracking-widest hover:bg-gray-900 transition-all active:scale-[0.98] shadow-lg shadow-black/10"
                                        >
                                            Submit Offer
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubCategoryAdd;
